
import React, { useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import optionIcon from "../../assets/images/bx_edit.svg";
import "../../assets/css/myAttendence.scss";
import ReactPaginate from "react-paginate";
import shareIcon from "../../assets/images/ic_export1.svg";
import BookIcon from "../../assets/images/ic_excel.svg";

const PrivacyPolicy = () => {
    const { sidebar, setSidebar, Dark, setDark } = useContext(AppContext);

    return (
        <>
            <div
                className={sidebar ? "taskMain " : "cx-active taskMain"}
                id="cx-main"
            >
                <div className="role-content-main">
                    <div className="sub-header-role mb-4">
                        <h6 className="mt-2">Privacy Policy</h6>
                    </div>

                    <div className="empolyDetails mb-4">
                        <div className="employeeDet">
                            <div>
                                <h3>Privacy Policy of Redbytes Software Pvt Ltd.</h3>
                                <p>This privacy policy governs the manner in which Redbytes Software Pvt Ltd. collects, uses, maintains, and discloses information collected from users (each referred to as a “user”) of the redbytes.in website (hereby referred to as “site”) and products including mobile applications. This privacy policy applies to the Site and all products and services offered by Redbytes Software Pvt Ltd.</p>
                                <p className="text-justify">
                                    Company Shall Lorem Ipsum passage, used since the 1500s "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum." Section 1.10.32 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC <br />
                                    "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?" 1914 translation by H. Rackham
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy